import { RESTDataSource } from "@apollo/datasource-rest";
import { safeParse } from "fast-content-type-parse";

//#region src/base-data-source/base-data-source.ts
var BaseDataSource = class extends RESTDataSource {
	logService;
	req;
	apimSubKey;
	baseURL;
	dataSourceName;
	constructor(config) {
		const { baseUrl, request, name, logService, apimSubKey } = config;
		super(config);
		this.baseURL = baseUrl.toString();
		this.req = request;
		this.dataSourceName = name ?? "DataSource";
		this.logService = logService;
		this.apimSubKey = apimSubKey;
	}
	async patch(path, request) {
		return await super.patch(path, request);
	}
	async post(path, request) {
		return await super.post(path, request);
	}
	async get(path, request) {
		return await super.get(path, request);
	}
	async delete(path, request) {
		return await super.delete(path, request);
	}
	catchCacheWritePromiseErrors(cacheWritePromise) {
		cacheWritePromise.catch((e) => {
			this.logService.error(e, {
				name: this.dataSourceName,
				message: "Error writing from RESTDataSource to cache"
			});
		});
	}
	parseBody(response) {
		const contentType = safeParse(response.headers.get("Content-Type") ?? "").type;
		const contentLength = response.headers.get("Content-Length");
		if (response.status !== 204 && contentLength !== "0" && contentType && (contentType.startsWith("application/json") || contentType.endsWith("+json"))) return response.json();
		else return response.text();
	}
	async trace(url, request, fn) {
		const startTime = Date.now();
		try {
			return await fn();
		} finally {
			const duration = Date.now() - startTime;
			this.logService.metric({
				name: request.metricName,
				namespace: this.dataSourceName,
				value: duration,
				url: url.toString(),
				method: request.method || "GET"
			});
		}
	}
	async retry(max, request, retries = 0) {
		const result = await request();
		if (!result) if (retries < max) return await this.retry(max, request, retries + 1);
		else throw new Error("Failed to retry");
		return result;
	}
};

//#endregion
export { BaseDataSource };